module.exports = __webpack_public_path__ + "static/media/thunghiem.0f53a506.png";